import { Box, Grid } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { SelectView } from "../../components/common/selectView/SelectView";
import ButtonView from "../../components/common/button/ButtonView";
import Typo from "../../components/common/typo/Typo";
import TableView from "../../components/common/dataTable/TableView";
import PartsForm from "../../components/survey/PartsForm";
import VehicleForm from "../../components/survey/VechicleForm";
import DialogView from "../../components/common/dialog/DialogView";
import SurveyDialogView from "../../components/survey/SurveyDialogView";
import "./Survey.css";
import excel from "../../assets/images/excel.svg";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import { useDispatch, useSelector } from "react-redux";
import { addItemInsurveyData } from "../../store/UpdateSurveyData";
import { useTranslation } from "react-i18next";
import {
  MONTH_LIST,
  HELPER_TEXT_STYLE,
  DISPLAY_LABEL,
  STOCK_LABEL,
  EXCEL_LABEL,
  EXPORT_SURVEY_LABEL,
  VEHICLE,
  PARTS,
  DATE_FORMATE,
  DATE_REVISED_FILTER_BY_LABEL,
  DATE_CREATED_FILTER_BY_LABEL,
  PRINT_LABEL,
} from "../../utils/GlobalConstants";
import {
  addItemInSelectedPart,
  addItemInSelectedSurvey,
  addItemInSelectedVehicle,
} from "../../store/SurveyPageData";
import { addSelectedSurveyId } from "../../store/ImportSlices";
import Loader from "../../components/common/dialog/Loader";
import DatePickerFilterBy from "../../components/common/datePicker/DatePickerFilterBy";
import moment from "moment";
import PrintDialogView from "../../components/survey/PrintDialogView";
import { downloadFile } from "../../utils/genericUse/SurveyCommon";

import {
  fetchAllSurvey,
  getRequestBlobDisplay,
  getRequestBlobExcel,
  getRequestBlobPrint,
  getRequestBlobStock,
  getSingleSurveyDetails,
  getStoreDetails,
  getSurveyWithFilter,
} from "../../services/SurveyRequest";
import { Snackbar, Alert } from '@mui/material';
import {
  NO_DATA,
  SURVEY_SELECT_MASG,
} from "../../utils/GlobalMessageConstants";
import { getDateString } from "../../utils/genericUse/CommonUse";

const Survey = () => {
  const [infoOpen, setInfoOpen] = useState(false);
  const [infoMsg, setInfoMsg] = useState('');
  const [severity, setSeverity] = useState('info');
  const [open, setOpen] = React.useState(false);
  const [show, setshow] = React.useState(false);
  const [surveyList, setSurveyList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [printOpen, setPrintOpen] = useState(false);
  const [createdDate, setCreatedDate] = useState(null);
  const [revisedDate, setRevisedDate] = useState(null);
  const [isFilterWithDate, setIsFilterWithDate] = useState(false);
  const [isDateCreatedClicked, setIsDateCreatedClicked] = useState(false);
  const [isRevisedDateClicked, setIsRevisedDateClicked] = useState(false);
  const [store, setStore] = useState();
  const [helperText, setHelperText] = useState();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const vinLoader = useSelector(
    (state) => state?.SurveyPageData?.vinLoader
  );
  const selectedSurvey = useSelector(
    (state) => state?.SurveyPageData?.selectedSurvey
  );
  const selectedSurveyId = useSelector(
    (state) => state?.ImportSlices?.selectedSurveyId
  );
  const downLoadType = "_stockList";

  const getSurveyDetails = useCallback(
    async (item) => {
      dispatch(addSelectedSurveyId(null));
      try {
        const surveyData = await getSingleSurveyDetails(item);
        dispatch(addItemInSelectedSurvey(surveyData?.survey));
        if (surveyData?.survey?.storeId) {
          try {
            const storeData = await getStoreDetails(
              surveyData?.survey?.storeId
            );
            setStore(storeData?.store?.storeName);
          } catch (e) {
            console.log(e);
          }
        } else {
          setStore("");
        }
        dispatch(addItemInSelectedVehicle({}));
        dispatch(addItemInSelectedPart({}));
        setIsLoading(false);
      } catch (e) {
        setIsLoading(false);
      }
    },
    [dispatch]
  );
useEffect(()=>{
  setIsLoading(vinLoader)
},[vinLoader])
  useEffect(() => {
    setIsLoading(true);
    getAllSurveys();
    if (selectedSurveyId) {
      getSurveyDetails(selectedSurveyId);
    }
  }, [getSurveyDetails, selectedSurveyId]);

  const getAllSurveys = async () => {
    try {
      const response = await fetchAllSurvey();
      setSurveyList(response?.surveys);
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const onHandleChangeUser = (item) => {
    setHelperText("");
    setIsLoading(true);
    getSurveyDetails(item);
    setshow(false);
    handleClearDateForFilter();
  };

  const dateConverter = (d) => {
    let dateconvert = new Date(d);
    let handleDate = dateconvert.getDate();
    if (handleDate >= 0 && handleDate <= 9) {
      handleDate = "0" + handleDate;
    }
    return (
      MONTH_LIST[dateconvert.getMonth()] +
      "-" +
      handleDate +
      "-" +
      dateconvert.getFullYear()
    );
  };

  const handleClose = () => {
    setOpen(false);
    dispatch(addItemInsurveyData({}));
  };

  const handleClosePrint = () => {
    setPrintOpen(false);
  };

  const handleChangeDate = (val) => {
    setCreatedDate(moment(val.$d).format(DATE_FORMATE));
    setIsDateCreatedClicked(true);
    setIsRevisedDateClicked(false);
  };

  const handleChangeRevisedDate = (revised) => {
    setRevisedDate(moment(revised.$d).format(DATE_FORMATE));
    setIsRevisedDateClicked(true);
    setIsDateCreatedClicked(false);
  };

  const handleClearDateForFilter = () => {
    setCreatedDate(null);
    setRevisedDate(null);
    setIsRevisedDateClicked(false);
    setIsDateCreatedClicked(false);
  };

  const handleFetchSurveysWithFilter = async (name) => {
    if (!isDateCreatedClicked && !isRevisedDateClicked) {
      getAllSurveys();
      setshow(false);
      dispatch(addItemInSelectedVehicle({}));
      dispatch(addItemInSelectedPart({}));
      dispatch(addItemInSelectedSurvey({}));
    } else {
      setIsLoading(true);
      let created = moment(createdDate).format(DATE_FORMATE);
      let revised = moment(revisedDate).format(DATE_FORMATE);
      try {
        const response = await getSurveyWithFilter(name, created, revised);
        setSurveyList(response?.surveys);
        setshow(false);
        setIsLoading(false);
        setIsFilterWithDate(true);
        handleShowSelectedFilterDate();
        dispatch(addItemInSelectedVehicle({}));
        dispatch(addItemInSelectedPart({}));
        dispatch(addItemInSelectedSurvey({}));
      } catch (e) {
        setIsLoading(false);
      }
    }
  };

  const handleShowSelectedFilterDate = () => {
    if (isFilterWithDate && isDateCreatedClicked && !isRevisedDateClicked) {
      return DATE_CREATED_FILTER_BY_LABEL + " -  " + createdDate;
    } else if (
      isFilterWithDate &&
      !isDateCreatedClicked &&
      isRevisedDateClicked
    ) {
      return DATE_REVISED_FILTER_BY_LABEL + " - " + revisedDate;
    } else {
      return "";
    }
  };

  const getChoiceItem = (choice) => {
    if (choice === 1) {
      return "UNIT_NO";
    } else if (choice === 2) {
      return "MAKE_MODEL";
    } else if (choice === 3) {
      return "SORT_BY";
    } else {
      return "";
    }
  };

  const getItemsChecked = (items) => {
    let checkedItems = {};
    for (let i = 0; i < items.length; i++) {
      if (items[i].checked) {
        checkedItems = { ...checkedItems, [items[i].key]: true };
      }
    }
    if (Object.keys(checkedItems).length === 0) {
      checkedItems = { ...checkedItems, [items[0].key]: true };
    }
    return checkedItems;
  };
  const handleInfoClose = (_, reason) => {
    if (reason === 'clickaway') return;
    setInfoOpen(false);
  };
  const getDisplay = async (type, choice, itemsCheck) => {
    setHelperText("");
    setPrintOpen(false)
    setSeverity('info');
    setInfoMsg('PDF generation is running in the background. Once ready, it will automatically download.');
    setInfoOpen(true);
    try {
      if (type === PRINT_LABEL) {
        let order_by = [];
        let Sort_by = getChoiceItem(choice.Sort_by);
        Sort_by && order_by.push(Sort_by);
        let then_by_Sort = getChoiceItem(choice.then_by_Sort);
        then_by_Sort && order_by.push(then_by_Sort);
        let then_by = getChoiceItem(choice.then_by);
        then_by && order_by.push(then_by);
        let payload = {
          surveyId: selectedSurvey.id,
          surveyName: selectedSurvey.surveyName,
          ...(order_by.length > 0 && { orderBy: [...new Set(order_by)] }),
          ...getItemsChecked(itemsCheck),
        };
        const response = await getRequestBlobPrint(payload);
        downloadFile(
          response,
          "application/pdf",
          selectedSurvey.surveyName + "_" + getDateString(),
          "pdf"
        );
       setSeverity('success');
      setInfoMsg( 'PDF is generated successfully '
      );
      setInfoOpen(true);
        handleClosePrint();
      }
    } catch (e) {
    setSeverity('error');
      setInfoMsg( e?.message || 'Something went wrong while generating the PDF.'
      );
      setInfoOpen(true);
      // handleInfoClose()
      setHelperText(NO_DATA);
    }
  };

  const getSurveyReport = async (type) => {
    if (selectedSurvey?.id) {
      setIsLoading(true);
      setHelperText("");
      try {
        if (type === DISPLAY_LABEL) {
          let payload = {
            surveyId: selectedSurvey.id,
            orderBy: ["UNIT_NO"],
            includeSurvey: true,
          };
          const response = await getRequestBlobDisplay(payload);
          downloadFile(
            response,
            "application/pdf",
            selectedSurvey.surveyName + "_" + getDateString(),
            "pdf"
          );
          setIsLoading(false);
        } else {
          if (type === STOCK_LABEL) {
            const response = await getRequestBlobStock(selectedSurvey.id);
            downloadFile(
              response,
              "application/vnd.ms-excel",
              selectedSurvey.surveyName + downLoadType + "_" + getDateString(),
              ".xlsx"
            );
            setIsLoading(false);
          } else if (type === EXCEL_LABEL) {
            const response = await getRequestBlobExcel(selectedSurvey.id);
            downloadFile(
              response,
              "application/vnd.ms-excel",
              selectedSurvey.surveyName + "_" + getDateString(),
              ".xlsx"
            );
            setIsLoading(false);
          }
        }
      } catch (e) {
        console.log(e);
        setIsLoading(false);
        setHelperText(NO_DATA);
      }
    } else {
      setHelperText(SURVEY_SELECT_MASG);
    }
  };

  const onClickPrint = () => {
    if (selectedSurvey?.id) {
      setHelperText("");
      setPrintOpen(true);
    } else {
      setHelperText(SURVEY_SELECT_MASG);
    }
  };

  return (
    <React.Fragment>
      <Snackbar
        open={infoOpen}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity={severity} onClose={handleInfoClose} sx={{ width: '100%' }}>
          {infoMsg}
        </Alert>
      </Snackbar>
      <DialogView
        testid="surveyDialog"
        open={open}
        heading={"Maintenance"}
        handleClose={() => {
          handleClose();
          getAllSurveys();
        }}
        childComponet={<SurveyDialogView />}
      />

      <DialogView
        testid="printDialog"
        open={printOpen}
        width={"45%"}
        heading={"Fleet Survey Report"}
        handleClose={() => {
          handleClosePrint();
        }}
        childComponet={
          <PrintDialogView
            testid="printDialogInner"
            selectedSurvey={selectedSurvey}
            handleClose={() => handleClosePrint()}
            handlePrint={(selectedChoice, itemsCheck) =>
              getDisplay("print", selectedChoice, itemsCheck)
            }
          />
        }
      />

      {/* Survey Display Section on Selection of a Survey -- Start*/}
      <div className="header-text-container">
        {selectedSurvey?.surveyName && (
          <>
            <div className="surveyDisplay">
              <Typo text={t("header.Displaying")} />
              <Typo className="surveyName" text={selectedSurvey?.surveyName} />
            </div>
            {store ? (
              <div className="jobberDisplay">
                <Typo text={t("header.Jobber")} />
                <Typo className="jobberName" text={store} />
              </div>
            ) : (
              ""
            )}
          </>
        )}
      </div>

      {/* Survey Display Section on Selection of a Survey -- End*/}
      {/* Main Survey Display -- Start */}
      <Box component="fieldset" className="fieldset-style">
        <legend className="legend-style">
          {t("tab1.contents.Survey_Information")}
        </legend>

        <Grid container className="centerAlignment" spacing={2}>
          {/* Survey Section DropDown */}
          <Grid item md={2} sm={2} lg={2} xs={12}>
            <SelectView
              testid="surveyselec"
              data={surveyList}
              label={t("tab1.contents.Select_Survey")}
              onHandleChange={(item) => onHandleChangeUser(item)}
              value={
                selectedSurvey && selectedSurvey.id ? selectedSurvey.id : ""
              }
            />
          </Grid>
          <Grid item mt={2} md={2} sm={2} lg={2} xs={12}>
            
            <ButtonView
              testid="addupdate"
              data-testid="survey-add-update-btn"
              label={t("tab1.contents.Add_Update_Survey")}
              onClick={() => handleClickOpen()}
            />
          </Grid>

          {/* Disabled Date Section */}
          <Grid item md={2} sm={2} lg={2} xs={12}>
            <div>
              <span className="dateCreated">
                {t("tab1.contents.Date_Created")}:
              </span>{" "}
              {selectedSurvey?.createdTs &&
                dateConverter(selectedSurvey?.createdTs)}
            </div>

            <div>
              <span className="dateCreated">
                {t("tab1.contents.Date_Revised")}:
              </span>{" "}
              {selectedSurvey?.lastUpdatedTs &&
                dateConverter(selectedSurvey?.lastUpdatedTs)}
            </div>
          </Grid>

          {/* Filter By Section */}
          <Grid item md={1} sm={1} lg={3} xs={12}>
            <div className="filterByPosition">
              <div
                testid="filter"
                onClick={() => {
                  setshow(!show);
                }}
              >
                <ButtonView label={t("tab1.contents.Filter_by")}></ButtonView>
                <span className="selected-date-text">
                  {handleShowSelectedFilterDate()}
                </span>
              </div>

              {show && (
                <DatePickerFilterBy
                  testid="datepicker"
                  createdDate={createdDate}
                  revisedDate={revisedDate}
                  handleChangeDate={handleChangeDate}
                  handleChangeRevisedDate={handleChangeRevisedDate}
                  handleFetchSurveysWithFilter={handleFetchSurveysWithFilter}
                  handleClearDateForFilter={handleClearDateForFilter}
                  isDateCreatedClicked={isDateCreatedClicked}
                  isRevisedDateClicked={isRevisedDateClicked}
                />
              )}
            </div>
          </Grid>
          {/* Right Icons Section */}
          <Grid item md={5} sm={5} lg={3} xs={12}>
            <div className="surveyIcons">
              <div
                testid={EXCEL_LABEL}
                className="iconBox"
                onClick={() => getSurveyReport(EXCEL_LABEL)}
              >
                <img
                  className="excelIcon"
                  alt="icon"
                  src={excel}
                  style={{
                    filter:
                      "brightness(0) saturate(100%) invert(6%) sepia(95%) saturate(7483%) hue-rotate(240deg) brightness(78%) contrast(108%)",
                  }}
                />
                <Typo
                  className="textSm"
                  text={t("tab1.contents.Export_Survey")}
                />
              </div>
              <div
                className="iconBox"
                onClick={() => onClickPrint()}
                testid={EXPORT_SURVEY_LABEL}
              >
                <LocalPrintshopOutlinedIcon className="surveyIconsStyle" />
                <Typo
                  className="textSm"
                  text={t("tab1.contents.Print_Survey")}
                />
              </div>
              <div
                className="iconBox"
                testid={STOCK_LABEL}
                onClick={() => getSurveyReport(STOCK_LABEL)}
              >
                <MenuOutlinedIcon
                  color="primary"
                  className="surveyIconsStyle"
                />
                <Typo className="textSm" text={t("tab1.contents.Stock_list")} />
              </div>
              <div
                className="iconBox"
                testid={DISPLAY_LABEL}
                onClick={() => getSurveyReport(DISPLAY_LABEL)}
              >
                <PictureAsPdfOutlinedIcon className="surveyIconsStyle" />
                <Typo className="textSm" text={t("tab1.contents.Display")} />
              </div>
            </div>
          </Grid>
          {helperText && (
            <Grid item>
              <Typo text={helperText} style={HELPER_TEXT_STYLE} />
            </Grid>
          )}
        </Grid>
      </Box>
      {/* Main Survey Display -- End */}
      {/* Vehicle Form -- Left ,Vehicle Table -- Right Section -- Start*/}
      <Box component="fieldset" className="fieldset-style">
        <legend className="legend-style">
          {t("tab1.contents.Vehicle_Information")}
        </legend>
        <Grid container className="afterSurveyGrid">
          <Grid item md={3.9} sm={12} lg={3.9} xs={12}>
            <VehicleForm />
          </Grid>
          <Grid item md={0.1} sm={12} lg={0.1} xs={12}></Grid>
          <Grid item md={8} sm={12} lg={8} xs={12}>
            <TableView className="table-style" source={VEHICLE} />
          </Grid>
        </Grid>
      </Box>

      {/* Vehicle Form -- Left ,Vehicle Table -- Right Section -- End */}

      {/* Parts Form -- Left ,Parts Table -- Right Section -- Start*/}
      <Box component="fieldset" className="fieldset-style">
        <legend className="legend-style">
          {t("tab1.contents.Parts_Information")}
        </legend>
        <Grid container className="afterSurveyGrid">
          <Grid item md={3.9} sm={12} lg={3.9} xs={12}>
            <PartsForm />
          </Grid>
          <Grid item md={0.1} sm={12} lg={0.1} xs={12}></Grid>
          <Grid item md={8} sm={12} lg={8} xs={12}>
            <TableView source={PARTS} />
          </Grid>
        </Grid>
      </Box>
      {/* Parts Form -- Left ,Parts Table -- Right Section -- End */}
      {isLoading && (
        <Loader data-testid="loading-sppiner-id" className="Loader-style" />
      )}
    </React.Fragment>
  );
};

export default Survey;
